import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";

interface Props {
  handleDelete: () => Promise<void> | void;
  disabled: boolean;
}

export const DeleteButton = ({ handleDelete, disabled }: Props) => {
  const { t } = useTranslate(["FilesBoxTable"]);

  return (
    <Tooltip title={t("Delete File", { ns: "FilesBoxTable" })}>
      <IconButton
        aria-label={t("Delete File", { ns: "FilesBoxTable" })}
        color="primary"
        onClick={handleDelete}
        size="small"
        disabled={disabled}
      >
        <DeleteIcon fontSize={"small"} />
      </IconButton>
    </Tooltip>
  );
};
